import type { SelectOption } from '@innovationdepartment/proxima-ui';
import { useShowSpinner } from 'hooks';
import { useEffect, useState } from 'react';
import type { BrandMasterTokenAdAccountProps } from 'types/brandOverview';
import DisconnectIntegrationModal from 'ui/Modals/DisconnectIntegrationModal';
import MasterTokenAdAccountView from './MasterTokenAdAccounts.View';

const MasterTokenAdAccount = (props: BrandMasterTokenAdAccountProps) => {
  const { masterAdAccounts, apiLoading, onConnectAdAccount, onDisconnectAdAccount } = props;

  const initialSelected = masterAdAccounts.find(account => account.connected);
  const [selected, setSelected] = useState(initialSelected);
  const [disconnectModalOpen, setDisconnectModalOpen] = useState(false);

  useShowSpinner({ show: apiLoading.masterAdAccounts ?? false });

  const onSelectChange = (value: string) => {
    setSelected(masterAdAccounts.find(account => account.accountId === value));
  };

  useEffect(() => {
    if (initialSelected) setSelected(initialSelected);
  }, [initialSelected]);

  const getSelectedAdAccount = () =>
    masterAdAccounts.find(account => account.accountId === selected?.accountId);

  const processAction = async (action: 'connect' | 'disconnect') => {
    const adAccount = getSelectedAdAccount();
    if (!adAccount) return;
    const isConnect = action === 'connect';
    await (isConnect ? onConnectAdAccount(adAccount) : onDisconnectAdAccount(adAccount));
    setSelected({ ...adAccount, connected: isConnect });
    setDisconnectModalOpen(false);
  };

  const onDisconnectClick = () => setDisconnectModalOpen(true);

  const onSwitchToggle = (toggle: boolean) => {
    if (toggle) {
      processAction('connect');
    } else {
      onDisconnectClick();
    }
  };

  const options: SelectOption[] = masterAdAccounts.map(account => ({
    label: account.name,
    value: account.accountId
  }));

  return (
    <>
      <MasterTokenAdAccountView
        options={options}
        loading={apiLoading.masterAdAccounts ?? true}
        selected={selected?.accountId}
        isConnected={selected?.connected ?? false}
        onSelectChange={onSelectChange}
        onSwitchToggle={onSwitchToggle}
      />
      <DisconnectIntegrationModal
        open={disconnectModalOpen}
        close={() => setDisconnectModalOpen(false)}
        confirm={() => processAction('disconnect')}
      />
    </>
  );
};

export default MasterTokenAdAccount;
